<template>
  <div>
    <payment-form
      v-if="showPaymentForm"
      :allowed-methods="allowedMethods"
      :amount="totalAmount"
      :cash-action-label="cashActionLabel"
      :currency-label="order.currency_label"
      :selected-method="order.payment_method || 'cash'"
      :pay-api="payApi()"
      @methodChanged="onMethodChange"
      @paid="onPaid"
      @error="onPayError"
    />
    <payment-status
      v-if="paymentStatus"
      :status="paymentStatus"
      @recheck="checkOrder"
    />
  </div>
</template>

<script>
import PaymentForm from './PaymentForm'
import PaymentStatus from './PaymentStatus'
import { createPayApi } from './Api'
import orderChecker from './orderChecker'

export default {
  name: 'PaymentFormWrapper',

  components: {
    PaymentForm,
    PaymentStatus,
  },

  props: {
    cashActionLabel: {
      type: String,
      default() {
        return this.$t('general.save')
      },
    },
    order: {
      type: Object,
      required: true,
    },
    allowedMethods: {
      type: Array,
      default: () => {
        return ['cash']
      },
    },
  },

  data() {
    return {
      paymentStatus: null,
    }
  },

  computed: {
    showPaymentForm() {
      return ['pending', 'partial'].indexOf(this.order.status) > -1
    },
    totalAmount() {
      return this.order.amount - this.order.amount_paid
    },
  },

  methods: {
    checkOrder() {
      this.order.status = 'pending_payment'
      this.paymentStatus = {
        message: this.$t('orders.messages.checking_payment'),
        recheck: false,
        variant: 'info',
      }

      return orderChecker(this.order.id, ['completed'])
        .then(() => {
          this.paymentStatus = {
            message: this.$t('orders.messages.paid'),
            recheck: false,
            variant: 'success',
          }
          this.$emit('paid')
        })
        .catch(() => {
          this.paymentStatus = {
            message: this.$t('orders.messages.unable_check_payment'),
            recheck: true,
            variant: 'warning',
          }
        })
    },
    onMethodChange(method) {
      this.paymentStatus = null
      this.$emit('methodChanged', method)
    },

    onPaid(method) {
      this.paymentStatus = null
      if (method === 'cash') {
        return
      }

      this.checkOrder()
    },

    onPayError(message) {
      this.paymentStatus = {
        message,
        recheck: false,
        variant: 'danger',
      }
    },

    payApi() {
      return createPayApi(this.order)
    },
  },
}
</script>
